const centerPanel = require('../../shop/views/center-panel.view.html').trim(),
    rightPanel = require('../../shop/views/right-panel.view.html').trim(),
    { assign } = require('lodash');

module.exports = ($stateProvider) => {
    const adobeParam = { cmpid: 'smaf014' };

    $stateProvider
        .state('shop.productdetails', {
        // temporary for old product description popup
            url: '/productdetails/{productId}/{productName}?{googleshop:bool}&{store_code:string}&{cmpid:string}&{reviewPageNumber:int}&{reviewSortBy}&{gclid}&{cvosrc}&{cvo_crid}&{cvo_campaign}',
            params: {
                product: null,
            },
            data: {
                pageMetadata: [
                    'DetailProductService', 'PageMetadataService', '$stateParams',
                    function (detailProductService, pageMetadataService, $stateParams) {
                        return detailProductService.getProductDetail($stateParams.productId).then(details => pageMetadataService.getMetadata({
                            name: `${details.Product.Name} ${details.Product.PackageSize}`.trim(),
                        }, null, null, 'Product'));
                    },
                ],
            },
            onEnter: ['$state', '$window', '$timeout', '$stateParams', 'Settings', 'RichRelevanceService', 'ShopperService', 'FulfilmentService',
                function ($state, $window, $timeout, $stateParams, settings, richRelevanceService, shopperService, fulfilmentService) {
                    if ($stateParams.googleshop && shopperService.IsGuest) {
                    /**
                     * Change store location
                     * if store code parameter is supplied, set store to the provided store code
                     * else use the default store code from the setting.
                     */
                        const storeCode = $stateParams.store_code && $stateParams.store_code.includes(settings.googleSem.storeCodeParamPrefix)
                            ? $stateParams.store_code.replace(settings.googleSem.storeCodeParamPrefix, '')
                            : settings.googleSem.defaultBasePriceStoreCode;

                        if (shopperService.shopper.FulfilmentStoreId !== parseInt(storeCode)) {
                            fulfilmentService.setStore(storeCode).then((response) => {
                            // this is needed because the store code supplied may not be the effective store code and without this it will enter an infinite loop.
                                if (response.EffectiveFulfilmentStoreId > 0 && shopperService.shopper.FulfilmentStoreId !== response.EffectiveFulfilmentStoreId) {
                                    const params = assign($stateParams, adobeParam);
                                    $window.location.href = $state.href($state.current, params, { absolute: true });
                                }
                            });
                        }
                    }

                    if ($stateParams.googleshop && !$stateParams.cmpid) {
                        $timeout(() => $state.go($state.current, assign($stateParams, adobeParam), { location: 'replace' }));
                    }

                    if ($stateParams.product) {
                        richRelevanceService.rrItemDetailsPageRequest($stateParams.product.Stockcode, $stateParams.product.Source);
                    }
                },
            ],
            resolve: {
                modules: [
                    '$ocLazyLoad', function ($ocLazyLoad) {
                        return $ocLazyLoad.load('productdetail');
                    },
                ],
            },
            views: {
                'content@root': {
                    template: `${centerPanel} ${rightPanel}`,
                },
                'center-panel@shop.productdetails': {
                    controller: ['DetailProductService', '$stateParams', function (detailProductService, $stateParams) {
                        if ($stateParams.product) {
                            this.detail = { Product: $stateParams.product };
                        }
                        detailProductService.getProductDetail($stateParams.productId).then((detail) => {
                            this.detail = detail;
                            this.isLoaded = true;
                        });
                    }],
                    controllerAs: '$ctrl',
                    template: '<wow-product-detail ng-if="$ctrl.detail" detail="$ctrl.detail" is-loaded="$ctrl.isLoaded"></wow-product-detail>',
                },
                'rr-instrumentation-panel@root': {
                    controller: ['$stateParams', 'Settings', 'RichRelevanceService',
                        function ($stateParams, settings, richRelevanceService) {
                            this.removeDuplicatedProducts = settings.richRelevance.removeDuplicatedProducts;
                            this.productId = $stateParams.productId;
                            this.productName = $stateParams.productName;
                            this.placementIds = `${richRelevanceService.itemPageRankOne}, ${richRelevanceService.itemPageRankTwo}`;
                        },
                    ],
                    controllerAs: '$ctrl',
                    template: '<wow-rr-item-instrumentation ng-if="!$ctrl.removeDuplicatedProducts" page-group="Category" item-id="$ctrl.productId" item-name="$ctrl.productName" placement-ids="$ctrl.placementIds"></wow-rr-item-instrumentation>',
                },
            },
        });
};



// WEBPACK FOOTER //
// ./src/configuration/routes/productdetail.js